import { Directive, input, InputSignal, inject, DestroyRef, effect } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { ScreenReaderService } from '../../services/screen-reader.service';

@Directive({
  selector: '[tdWbScreenReaderVisibility]'
})
export class ScreenReaderVisibilityDirective{
  readonly tdWbScreenReaderVisibility: InputSignal<boolean> = input(false);

  private ariaHiddenElements: Map<Element, string> = new Map<Element, string>();

  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly document: Document = inject(DOCUMENT);

  constructor() {
    effect(() => {
      const visible = this.tdWbScreenReaderVisibility();
      this.toggleNonOverlayContentScreenReaderVisibility(!visible);

    });
    this.destroyRef.onDestroy(() => {
      this.toggleNonOverlayContentScreenReaderVisibility(true);
    });
  }

  private toggleNonOverlayContentScreenReaderVisibility(visible: boolean): void {
    if (visible) {
      ScreenReaderService.contentVisible(this.ariaHiddenElements);
    } else {
      const overlayContainer = this.document.getElementsByClassName('cdk-overlay-container');
      if (overlayContainer !== undefined && overlayContainer !== null && overlayContainer.length > 0) {
        ScreenReaderService.contentHidden(overlayContainer[0] as HTMLElement, this.ariaHiddenElements);
      }
    }
  }
}
